import { FC, useState } from "react";
import FormGroup from "../components/FormGroup";
import OrganizationFormSection from "./../components/OrganizationFormSection";
import ParticipantList from "./../components/ParticipantsList";
import { IParticipant, IOrganization } from "../types";
import { useNavigate } from "react-router-dom";
import { AccommodationTypeDto } from "../types/contracts";

const FormGroupPage: FC = () => {
  const [participants, setParticipants] = useState<IParticipant[]>([]);
  const [organization, setOrganization] = useState<IOrganization>();
  const [eventId, setEventId] = useState<string>("");
  const [eventName, setEventName] = useState<string>("");
  const [accommodations, setAccommodations] = useState<AccommodationTypeDto[]>(
    []
  );

  const navigate = useNavigate();
  const isDisabled = participants.length === 0 || !organization;

  const handleFormChange = (newParticipant: IParticipant) => {
    newParticipant.stayDates = Array.isArray(newParticipant.stayDates)
      ? newParticipant.stayDates
      : [newParticipant.stayDates];
    setParticipants((prevParticipants) => [
      ...prevParticipants,
      newParticipant,
    ]);
    console.log("eventId: ");
    console.log(newParticipant.eventId);
    setEventId(newParticipant.eventId);
    setEventName(newParticipant.eventName);
  };

  const handleOrganizationFormChange = (organization: IOrganization) => {
    setOrganization(organization);
  };

  const removeParticipant = (indexToRemove: number) => {
    setParticipants(participants.filter((_, index) => index !== indexToRemove));
  };

  const handleSummaryClick = () => {
    if (isDisabled) return;

    navigate("/form-summary", {
      state: {
        summary: {
          participants,
          organization,
          eventId,
          feeTypeId: participants[0].feeTypeId,
          eventName,
        },
      },
    });
  };

  return (
    <>
      <div className="my-5">
        <OrganizationFormSection
          onFormChange={handleOrganizationFormChange}
          accommodations={accommodations}
        />
        <FormGroup
          onFormChange={handleFormChange}
          accommodations={accommodations}
          setAccommodations={setAccommodations}
        />
        <ParticipantList
          participants={participants}
          onRemove={removeParticipant}
        />
        <div className="py-5 mx-auto max-w-4xl text-right">
          <button
            onClick={handleSummaryClick}
            disabled={isDisabled}
            className={`font-bold py-4 px-8 rounded-lg ${
              isDisabled
                ? "bg-gray-400 text-white cursor-not-allowed"
                : "bg-green-500 hover:bg-green-600 text-white"
            }`}
          >
            Shrnutí
          </button>
        </div>
      </div>
    </>
  );
};

export default FormGroupPage;
